<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('customerProfile.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('customerProfile.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button>
          <div class="d-flex ts-space-x-3">
            <ts-input
              v-model="search"
              v-tooltip="$t('customerProfile.search')"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
            <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{ $t('customerProfile.branchName') }}</label>
                  <ts-branch-filter
                    @filter="branchFilter" 
                    class="ts-w-full"
                  ></ts-branch-filter>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="ts-overflow-auto">
         <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.branch.branch_name_en }}</td>
          <td>{{ record.customer_code }}</td>
          <td>{{ record.customer_name }}</td>
          <td>{{ record.gender }}</td>
          <td>{{ record.contact_number }}</td>
          <td>{{ record.ss_id_card }}</td>
          <td>{{ record.type.customer_type }}</td>
          <td>{{ record.contact_email }}</td>
          <!-- <td>{{ record.account_number }}</td> -->
          <td class="ts-text-center">
              <span class="badge badge-success" v-if="record.is_general_customer">Yes</span>
              <span class="badge badge-danger" v-else>No</span>
          </td>
          <td class="ts-text-center">
              <span class="badge badge-success" v-if="record.is_membership">Yes</span>
              <span class="badge badge-danger" v-else>No</span>
          </td>
          <td class="ts-text-right">
            {{ record.membership_discount_rate }}
          </td>
          <td class="text-center ts-space-x-3">
            <a
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(record)"
            >
              <a href="#" :disabled="record._deleting">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm>
          </td>
        </template>
      </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('customerProfile.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
        width="60%"
      >
        <from-action
          @cancel="clearEdit"
          @fetchData="fetchData"
        />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'

export default {
  name: 'customerProfileIndex',
  components: {
    FromAction
  },
  data() {
    return {
      loading: false,
      showForm: false
    }
  },
  computed: {
    ...mapState('customer/profile', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.customer.profile.search
      },
      set(newValue) {
        this.$store.commit('customer/profile/SET_SEARCH', newValue)
        this.$store.commit('customer/profile/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('customerProfile.branchName') },
        { name: this.$t('customerProfile.customerCode') },
        { name: this.$t('customerProfile.customerName') },
        { name: this.$t('customerProfile.gender') },
        { name: this.$t('customerProfile.phoneNumber') },
        { name: this.$t('customerProfile.idCard') },
        { name: this.$t('customerProfile.customerType') },
        { name: this.$t('customerProfile.email') },
        // { name: this.$t('customerProfile.accountNumber') },
        { name: this.$t('customerProfile.isGeneralCustomer'),  style: 'text-align:center' },
        { name: this.$t('customerProfile.isMembership'),  style: 'text-align:center' },
        { name: this.$t('customerProfile.discountRate'),  style: 'text-align:right' },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('customer/profile/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
    edit(record) {
      this.$store.commit('customer/profile/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit(){
       this.$store.commit('customer/profile/SET_EDIT_DATA', {})
      this.showForm = false
		},
		deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('customer/profile/destroy', record.customer_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    branchFilter(value){
      this.$store.commit('customer/profile/SET_BRANCH_ID', value)
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('customer/profile/RESET_STATE')
    this.$store.commit('customer/profile/CLEAR_STATE')
    next()
  }
}
</script>
